<template>
  <v-menu
    v-model="open"
    offset-y
    left
    :close-on-content-click="false"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        x-small
        class="ml-1 flex-shrink-0"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon
          small
          color="grey"
        >
          mdi-dots-horizontal
        </v-icon>
      </v-btn>
    </template>
    <v-card class="pa-3">
      <template v-if="!submitted">
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-btn
              icon
              small
              :disabled="loading"
              @click="submit('up')"
            >
              <v-icon color="primary-grey lighten-1">
                mdi-thumb-up
              </v-icon>
            </v-btn>
            <v-btn
              icon
              small
              :disabled="loading"
              @click="submit('down')"
            >
              <v-icon color="primary-grey lighten-1">
                mdi-thumb-down
              </v-icon>
            </v-btn>
            <span class="text-body-1 ml-1 mr-3">Helpful?</span>
          </div>
          <v-btn
            icon
            x-small
            @click="open = false"
          >
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </div>
      </template>
      <template v-else>
        <div class="d-flex align-center justify-space-between">
          <span class="partner-feedback-label">Thanks for your feedback!</span>
          <v-btn
            icon
            x-small
            @click="open = false"
          >
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-card>
  </v-menu>
</template>

<script>
import { postRequest } from '@/helpers/request';

export default {
  name: 'PartnerFeedbackMenu',

  props: {
    cardId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      open: false,
      loading: false,
      submitted: false,
    };
  },

  watch: {
    cardId() {
      this.open = false;
      this.submitted = false;
    },
  },

  methods: {
    async submit(vote) {
      if (this.loading) return;
      this.loading = true;
      try {
        await postRequest('/api/partner-cards/feedback/', { card_id: this.cardId, vote });
        this.submitted = true;
        setTimeout(() => { this.open = false; }, 2000);
      } catch (e) {
        // fail silently — feedback is non-critical
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
